import axios from "../axios";
import { downloadHsePdfBlob, raiseHsePdfRequestError } from "./downloadPdf";

// Get all safety inspections
export const getHseSafetyInspections = async (params = {}) => {
  const response = await axios.get("/hse_safety_inspections", { params });
  return response;
};

// Get a single safety inspection
export const getHseSafetyInspection = async (id) => {
  const response = await axios.get(`/hse_safety_inspections/${id}`);
  return response;
};

// Create a new safety inspection
export const createHseSafetyInspection = async (data) => {
  const response = await axios.post("/hse_safety_inspections", {
    hse_safety_inspection: data,
  });
  return response;
};

// Update a safety inspection
export const updateHseSafetyInspection = async (id, data) => {
  const response = await axios.put(`/hse_safety_inspections/${id}`, {
    hse_safety_inspection: data,
  });
  return response;
};

// Delete a safety inspection
export const deleteHseSafetyInspection = async (id) => {
  const response = await axios.delete(`/hse_safety_inspections/${id}`);
  return response;
};

// Complete a safety inspection
export const completeHseSafetyInspection = async (id) => {
  const response = await axios.put(`/hse_safety_inspections/${id}/complete`);
  return response;
};

// Close a safety inspection
export const closeHseSafetyInspection = async (id) => {
  const response = await axios.put(`/hse_safety_inspections/${id}/close`);
  return response;
};

// Add participants to a safety inspection
export const addParticipantsToSafetyInspection = async (id, participants) => {
  const response = await axios.put(
    `/hse_safety_inspections/${id}/add_participants`,
    {
      participants,
    }
  );
  return response;
};

// Add contacts to a safety inspection
export const addContactsToSafetyInspection = async (id, contacts) => {
  const response = await axios.put(
    `/hse_safety_inspections/${id}/add_contacts`,
    {
      contacts,
    }
  );
  return response;
};

// Add checkpoints to a safety inspection
export const addCheckpointsToSafetyInspection = async (id, checkpoints) => {
  const response = await axios.put(
    `/hse_safety_inspections/${id}/add_checkpoints`,
    {
      checkpoints,
    }
  );
  return response;
};

// Get results for a safety inspection
export const getSafetyInspectionResults = async (id) => {
  const response = await axios.get(`/hse_safety_inspections/${id}/get_results`);
  return response;
};

// Update a result
export const updateSafetyInspectionResult = async (
  inspectionId,
  resultId,
  data
) => {
  const response = await axios.put(
    `/hse_safety_inspections/${inspectionId}/update_result`,
    {
      result_id: resultId,
      result: data,
    }
  );
  return response;
};

// Print a safety inspection
export const printSafetyInspection = async (id, printType) => {
  const response = await axios.put(`/hse_safety_inspections/${id}/print`, {
    printType,
  });
  return response;
};

export async function exportHseSafetyInspectionPdf(id, filename) {
  try {
    const response = await axios.get(`/hse_safety_inspections/${id}/export_pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    });
    await downloadHsePdfBlob(
      response.data,
      filename || `hse-vernerunde-${id}.pdf`
    );
  } catch (error) {
    await raiseHsePdfRequestError(error);
  }
}

// Get statistics for safety inspections
export const getSafetyInspectionStatistics = async (params = {}) => {
  const response = await axios.get("/hse_safety_inspections/statistics", {
    params,
  });
  return response;
};
